// @flow

import formatDistanceStrict from 'date-fns/formatDistanceStrict';
// import distanceInWords from 'date-fns/distance_in_words';
// import distanceInWords from 'date-fns/distance_in_words_strict';
// import distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import _format from 'date-fns/format';
// import {da} from 'date-fns/esm/locale'
// import da from 'date-fns/locale/da';
import da from './date-fns-locale-da';

export function format(date: Date | string | number, formatStr: string) {
  return _format(date, formatStr, { locale: da });
}

export function distance(
  date: Date | string | number,
  baseDate: Date | string | number = new Date()
) {
  return `${formatDistanceStrict(date, baseDate, { locale: da })}`;
}
